let seoData = {
  lang: "",
  meta: {
    description: "",
  },
  ogTags: {
    description: "",
    image: "",
    locale: "",
    title: "",
    type: "",
    url: "",
  },
  title: "",
}

const setSeoData = data => {
  const { lang, title, field_seo, image, room } = data

  seoData.pageTitle = title
  seoData.lang = seoData.ogTags.locale = lang
  seoData.title = seoData.ogTags.title = title + " | Veranda Resorts"
  seoData.meta.description = room?.room_description.processed.replace(/(<([^>]+)>)/gi, "")

  if (image) {
    seoData.ogTags.image = image
  }

  if (field_seo) {
    if (field_seo.title) {
      seoData.title = seoData.ogTags.title = field_seo.title
    }

    if (field_seo.description) {
      seoData.meta.description = seoData.ogTags.description = field_seo.description
    }

    if (field_seo.og_type) {
      seoData.ogTags.type = field_seo.og_type
    }

    // Override OG tag title
    if (field_seo.og_title) {
      seoData.ogTags.title = field_seo.og_title
    }

    // Override OG tag description
    if (field_seo.description) {
      seoData.ogTags.description = field_seo.description
    }

    if (!field_seo?.description) {
      seoData.meta.description = field_seo.description
    }

    // Override OG tag image
    if (field_seo.og_image) {
      seoData.ogTags.image = field_seo.og_image
    }

    // Override OG tag locale
    if (field_seo.og_locale) {
      seoData.ogTags.locale = field_seo.og_locale
    }

    if (field_seo.og_url) {
      seoData.ogTags.url = field_seo.og_url
    }
  }

  return seoData
}

// If meta description is not set use the first component description as meta description
const getMetaDescriptionFromComponents = (field_seo, components) => {
  let description = ""

  if (components.length > 0) {
    //Trim html tags from description
    if (components[0].description?.value.match(/(<([^>]+)>)/gi)) {
      description = components[0].description?.value
        ? components[0].description.value.replace(/(<([^>]+)>)/gi, "")
        : ""
    } else {
      description = components[0].description?.value
        ? components[0].description.value
        : ""
    }
  }

  if (!field_seo?.description) {
    return description
  }

  return field_seo.description
}

export { setSeoData, getMetaDescriptionFromComponents }
